export default {"src":"/_next/static/media/ArrowRight.99e80eab.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};